export default "__VITE_ASSET__BV0ucS37__"